import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { withStyles, makeStyles, createStyles } from "@material-ui/core/styles";
import { Grid, IconButton, Drawer, Box,  Typography, Button, CircularProgress } from "@material-ui/core";
import { getPicTreeRainbowListDetail, getPicTreeLatLonByPowerAssetId } from "actions";
import MUIDataTable from "mui-datatables";
import MapIcon from '@material-ui/icons/Map';
import * as H from "helper";

const useStyles = makeStyles((theme) =>
  createStyles({
    volt: {
      paddingTop: theme.spacing(0.5),
      backgroundColor: "#fd5842",
      color: "#fff",
    },
    ampere: {
      paddingTop: theme.spacing(0.3),
      backgroundColor: "#4ba0c1",
      color: "#fff",
    },
    watt: {
      paddingTop: theme.spacing(0.5),
      backgroundColor: "#6eb26e",
      color: "#fff",
    },
    tableHead: {
      height: 48,
      backgroundColor: "#fafafa",
    },
    tableRow: {
      height: 32,
      "&:hover": {
        backgroundColor: theme.palette.action.hover,
      },
    },
    tableRowNone: {
      height: 126,
    },
    tblHead: {
      textAlign: "center",
      fontSize: 14,
      fontWeight: 500,
    },
    tblHeadLeft: {
      textAlign: "left",
      fontSize: 14,
      fontWeight: 500,
    },
    tblDataCenter: {
      textAlign: "center",
    },
    tblDataLeft: {
      textAlign: "left",
    },
    customTitle: {
      fontSize: 16,
      color: "#000",
    },
  })
);

const RainbowDetailList = ({
  pageTopLoader,
  rainbowListDetail,
  getPicTreeRainbowListDetail,
  getPicTreeLatLonByPowerAssetId,
  latLonByPowerAssetId,
  dateRange,
}) => {
  const classes = useStyles();
  const [initialDataCall, setInitialDataCall] = useState(true);
  const [mapDrawerOpen, setMapDrawerOpen] = useState(false);

  const hasLatLon = latLonByPowerAssetId.length > 0;
  const lat = hasLatLon ? latLonByPowerAssetId[0].latitude : null;
  const lon = hasLatLon ? latLonByPowerAssetId[0].longitude : null;

  useEffect(() => {
    if (
      dateRange && dateRange[0] !== null &&
      initialDataCall
    ) {
      getPicTreeRainbowListDetail();
      setInitialDataCall(false);
    }
  }, [dateRange]);

  const columns = [
    {
      name: "アセット識別子",
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value) => {
          return <div className={classes.tblDataCenter}>{value}</div>;
        },
      },
    },
    {
      name: "アセットID",
      options: {
        filter: false,
        sort: true,
        customBodyRender: (value) => {
          return <div className={classes.tblDataCenter}>{value}</div>;
        },
      },
    },
    {
      name: "報酬コード",
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value) => {
          return <div className={classes.tblDataCenter}>{value}</div>;
        },
      },
    },
    {
      name: "報酬タイプ",
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value) => {
          return <div className={classes.tblDataCenter}>{value}</div>;
        },
      },
    },
    {
      name: "宝箱レアリティ",
      options: {
        filter: true,
        customBodyRender: (value) => {
          return <div className={classes.tblDataCenter}>{value}</div>;
        },
      },
    },
    {
      name: "数量",
      options: {
        filter: false,
        customBodyRender: (value) => {
          return <div className={classes.tblDataCenter}>{value}</div>;
        },
      },
    },
    {
      name: "プレイヤーID",
      options: {
        filter: false,
        customBodyRender: (value) => {
          return <div className={classes.tblDataLeft}>{value}</div>;
        },
      },
    },
    {
      name: "プレイヤー名",
      options: {
        filter: false,
        customBodyRender: (value) => {
          return <div className={classes.tblDataLeft}>{value}</div>;
        },
      },
    },
    {
      name: "排出日時",
      options: {
        filter: false,
        sort: true,
        // customBodyRender: (value) => {
        //   return <div className={classes.tblDataCenter}>{H.FormatNumStrHelper.formatCommaThousand(value)}</div>;
        // },
        customBodyRender: (value) => {
          return <div className={classes.tblDataLeft}>{value}</div>;
        },
      },
    },
    { name: "地図",
      options: {
        filter: false,
        sort: false,
        customBodyRender: (value) => {
          return <IconButton onClick={() => handleOpenMap(value)}>
              <MapIcon fontSize="small" />
            </IconButton>;
        },
      },
    }
  ];
  const options = {
    filterType: "checkbox",
    filter: true,
    pagination: true,
    search: true,
    print: false,
    download: true,
    viewColumns: false,
    downloadOptions: {
      filename: "レインボー排出一覧データ",
      filterOptions: {
        useDisplayedColumnsOnly: true,
        useDisplayedRowsOnly: true,
      },
    },
    selectableRows: "none",
    rowsPerPage: 100,
    textLabels: {
      body: {
        noMatch: pageTopLoader ? "データ取得中です" :
         rainbowListDetail.length === 0 ? "データがありません" : "",
        toolTip: "",
      },
      toolbar: {
        search: "検索",
        viewColumns: "列の表示",
        downloadCsv: "CSVダウンロード",
        filterTable: "テーブルのフィルター",
      },
      viewColumns: {
        title: "表示する列",
        titleAria: "テーブルの列の表示/非表示",
      },
      pagination: {
        next: "次のページ",
        previous: "前のページ",
        rowsPerPage: "表示件数",
      },
      filter: {
        all: "全て",
        title: "フィルター",
        reset: "リセット",
      },
      selectedRows: {
        text: "レコードを選択",
        delete: "削除",
        deleteAria: "選択したレコードを削除する",
      },
    },
    rowsPerPageOptions: [10, 20, 50, 100],
  };

  const handleOpenMap = (value) => {
    getPicTreeLatLonByPowerAssetId(value);
    setMapDrawerOpen(true);
  };

  const handleCloseMap = () => {
    setMapDrawerOpen(false);
  };

  return (
    <>
      <Grid container spacing={1}>
        <Grid item sm={12}>
          <MUIDataTable
            title={<span className={classes.customTitle}>レインボー排出一覧</span>}
            data={rainbowListDetail}
            columns={columns}
            options={options}
          />
        </Grid>
      </Grid>
      <Drawer anchor="right" open={mapDrawerOpen} onClose={handleCloseMap}>
        <Box
          style={{
            width: 480,
            height: '100vh', // 高さを画面にフィットさせる
            display: 'flex',
            flexDirection: 'column',
          }}
        >
          <Box p={1}>
            <Typography variant="h6">電柱位置</Typography>
          </Box>
          <Box
            style={{
              flex: 1,
              overflowY: 'auto',
            }}
          >
          {latLonByPowerAssetId.length == 0 &&
            <Box p={2} style={{ textAlign: 'center', marginTop: '50%' }}>
              <CircularProgress size={40} />
            </Box>
          }
          {hasLatLon &&
            <iframe
              title="map"
              width="100%"
              height="100%"
              frameBorder="0"
              style={{ border: 0 }}
              loading="lazy"
              allowFullScreen
              src={`https://www.google.com/maps?q=${lat},${lon}&z=16&hl=ja&output=embed`}
            />
          }
          </Box>
          <Box p={2} style={{ textAlign: 'center' }}>
            {hasLatLon &&
            <Button
              href={`https://www.google.com/maps/@?api=1&map_action=pano&viewpoint=${lat},${lon}`}
              target="_blank"
              rel="noopener noreferrer"
              variant="outlined"
            >
              ストリートビューで開く
            </Button>
            }
          </Box>
        </Box>
      </Drawer>
    </>
  );
};

RainbowDetailList.propTypes = {
  classes: PropTypes.object,
};

const mapStateToProps = (state) => ({
  pageTopLoader: state.page.pageTopLoader,
  dateRange: state.page.dateRangePicTree,
  rainbowListDetail: state.pictree.rainbowListDetail,
  latLonByPowerAssetId: state.pictree.latLonByPowerAssetId,
});

const mapDispatchToProps = (dispatch) => ({
  getPicTreeRainbowListDetail: (param) => dispatch(getPicTreeRainbowListDetail(param)),
  getPicTreeLatLonByPowerAssetId: (param) => dispatch(getPicTreeLatLonByPowerAssetId(param)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(null, { withTheme: true })(RainbowDetailList));
